// extracted by mini-css-extract-plugin
module.exports = {"mobileExternalLink":"mobileExternalLink__1Pu2Z","tabRowWrapper":"tabRowWrapper__2DTK2","tabRow":"tabRow__71oZD","singleOptionTabRow":"singleOptionTabRow__18tGP"};